<div class="d-flex flex-column align-items-center justify-content-center">
  <div class="form w-50" *ngIf="!submitted; else confirmationMessage">
    <h4 class="mb-3">Forgot Password</h4>
    <p>Enter your email address and we'll send you a link to reset your password.</p>

    <form [formGroup]="forgotPasswordForm" (submit)="onSubmit()">
      <div class="row m-3">
        <label for="email">Email*</label>
        <input class="col form-field" name="email" formControlName="email" />
      </div>

      <div class="row m-3" *ngIf="forgotPasswordForm.controls['email'].invalid && forgotPasswordForm.controls['email'].touched">
        <label style="color: red">A valid email address is required</label>
      </div>

      <div class="row m-3" *ngIf="errorMessages.length > 0">
        <label style="color: red" *ngFor="let msg of errorMessages">{{ msg }}</label>
      </div>

      <div class="row m-3">
        <button class="col btn btn-primary" [disabled]="!forgotPasswordForm.valid || submitting" type="submit">
          {{ submitting ? 'Sending...' : 'Send Reset Link' }}
        </button>
      </div>

      <div class="row m-3">
        <a routerLink="/identity/signin">Back to Sign In</a>
      </div>
    </form>
  </div>

  <ng-template #confirmationMessage>
    <div class="form w-50">
      <h4 class="mb-3">Check Your Email</h4>
      <p>If an account exists with that email address, you'll receive a password reset link shortly.</p>
      <div class="row m-3">
        <a routerLink="/identity/signin">Back to Sign In</a>
      </div>
    </div>
  </ng-template>
</div>
